// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","MenuItem":"bfr_a bgu_un bgu_cw bgu_a","MenuItem__Btn":"bfr_b bgu_z"};